module.exports = __webpack_public_path__ + "media/images/icons/message-light-35eec5010f2f9ba74b42e28739bf7c34.svg";